import { TXTWCL_Does_not_include_N0 } from '../translations';
import type { Error } from '../types';

export const mustNotIncludeFieldValue =
  (fieldName: string) =>
  (inputValue: string | undefined, allValues: Record<string, string>): Error => ({
    valid:
      !allValues[fieldName] ||
      !inputValue ||
      !inputValue.toLowerCase().includes(allValues[fieldName].toLowerCase()),
    message: { ...TXTWCL_Does_not_include_N0, values: { 0: allValues[fieldName] } }
  });
